import { Link } from "react-router-dom";
import { ChapterEmblem } from "@/lib/brand";
import LooxsLogo from "@/components/LooxsLogo";

export default function World() {
  return (
    <div className="section-dark">
      {/* Hero — cream/beige, no invented model imagery, official logo. */}
      <section className="relative h-[92vh] overflow-hidden text-ink" style={{ background: "#efe7d7" }}>
        <div className="absolute inset-0" style={{
          background: "radial-gradient(ellipse at 50% 40%, #f5ecd8 0%, #ead9b6 55%, #d9c39a 100%)"
        }} />
        <div className="absolute inset-0" style={{
          background: "linear-gradient(120deg, transparent 30%, rgba(201,169,97,0.14) 45%, transparent 60%)",
        }} />
        <div className="grain opacity-40" />
        <div className="relative h-full flex flex-col justify-center items-center text-center px-8 pt-24">
          <p className="text-[10px] tracking-luxury uppercase text-goldDark mb-8">Enter</p>
          <div className="mb-10"><LooxsLogo height={120} /></div>
          <h1 className="font-editorial text-6xl md:text-9xl leading-[0.9] tracking-tight">The World<br /><em className="font-editorial-italic text-goldDark">of LOOXS.</em></h1>
        </div>
      </section>

      <section className="max-w-4xl mx-auto text-center px-8 py-32 md:py-40">
        <p className="text-[10px] tracking-luxury uppercase text-gold mb-6">The Philosophy</p>
        <p className="font-editorial text-3xl md:text-5xl leading-[1.2]">
          LOOXS is not a label. It is a private universe of contemporary luxury, structured across eleven chapters and lived through the individuals who choose it.
        </p>
      </section>

      <section className="bg-onyx py-24 md:py-32">
        <div className="max-w-[1200px] mx-auto px-8 md:px-16 grid md:grid-cols-3 gap-16">
          {[
            {title: "London",  body: "The design house sits between Marylebone and Fitzrovia — where the language of British tailoring is reinterpreted for a modern silhouette."},
            {title: "India",   body: "Every LOOXS piece is crafted in ateliers we know by name. Hand-finished. Slow. Considered."},
            {title: "Chapters",body: "Eleven chapters organise the universe. Each with its own material, its own mood, its own emblem."},
          ].map((f, i) => (
            <div key={i} className="animate-fade-up" style={{ animationDelay: `${i*100}ms` }}>
              <p className="text-[10px] tracking-luxury uppercase text-gold mb-4">{String(i+1).padStart(2,"0")}</p>
              <h3 className="font-editorial text-3xl mb-4">{f.title}</h3>
              <div className="rule-gold w-10 mb-4" />
              <p className="text-ivory/70 leading-relaxed">{f.body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Symbols — the LOOXS visual system: chapter emblems ARE allowed to be generated */}
      <section className="py-24 md:py-32 bg-ink">
        <div className="max-w-[1400px] mx-auto px-8 md:px-16 text-center">
          <p className="text-[10px] tracking-luxury uppercase text-gold mb-6">The Symbols</p>
          <h2 className="font-editorial text-4xl md:text-6xl tracking-tight">A visual grammar.</h2>
          <div className="rule-gold w-24 mx-auto my-10" />
          <p className="max-w-2xl mx-auto text-ivory/70 leading-relaxed mb-16">
            Eleven chapters, eleven provisional marks. Each mark is a considered study — silhouette, mood and material distilled to a single line.
          </p>
          <div className="grid grid-cols-3 md:grid-cols-5 gap-8 md:gap-12">
            {["I","II","III","IV","V","VI","VII","VIII","IX","X","XI"].map((r, i) => (
              <div key={r} className="animate-fade-up flex flex-col items-center" style={{ animationDelay: `${i*40}ms` }}>
                <div className="text-ivory/70">
                  <ChapterEmblem roman={r} size={56} stroke="currentColor" />
                </div>
                <p className="font-editorial text-2xl mt-4">{r}</p>
              </div>
            ))}
          </div>
          <Link to="/chapters" className="inline-block mt-16 tracking-widest-plus text-[11px] uppercase text-gold link-draw">Enter the chapters →</Link>
        </div>
      </section>
    </div>
  );
}
